export default {
  manager: null,
}
